import * as CSSO from "../../../shared/types/csso.types";
import faker from "faker";

export const createId = (): string => faker.random.alphaNumeric(10);

export const createContactInfo = (): CSSO.ContactInfo => {
  const fname = faker.name.firstName();
  const lname = faker.name.lastName();
  const email = faker.internet.email(fname, lname);

  return {
    id: createId(),
    name: `${fname} ${lname}`,
    email: email,
  };
};
